<!--  -->
<template>
  <div class="widget-item-container">
    <a-form-item
      class="widget-view"
      v-if="element"
      :key="element.key"
      :class="{ active: selectWidget?.key === element.key }"
      :rules="element.options.rules"
    >
      <label slot="label">
        <a-tooltip>
          <template #title>{{element.label}}</template>
          {{element.label}}
        </a-tooltip>
      </label>
      <template v-if="element.type === 'input'">
        <a-input
          readonly
          :size="config.size"
          :value="element.options.defaultValue"
          :style="{ width: element.options.width }"
          :placeholder="element.options.placeholder"
          :maxlength="parseInt(element.options.maxlength)"
          :prefix="element.options.prefix"
          :suffix="element.options.suffix"
          :addonBefore="element.options.addonBefore"
          :addonAfter="element.options.addonAfter"
          :allowClear="element.options.allowClear"
          :disabled="element.options.disabled"
        />
      </template>
      <template v-if="element.type === 'textarea'">
        <a-textarea
          style="resize: none"
          readonly
          :size="config.size"
          :rows="element.options.rows"
          :value="element.options.defaultValue"
          :style="{ width: element.options.width }"
          :placeholder="element.options.placeholder"
          :maxlength="element.options.maxlength"
          :showCount="element.options.showCount"
          :autoSize="element.options.autoSize"
          :allowClear="element.options.allowClear"
          :disabled="element.options.disabled"
        />
      </template>
      <template v-if="element.type === 'radio'">
        <a-radio-group
          :size="config.size"
          :value="element.options.defaultValue"
          :style="{ width: element.options.width }"
          :disabled="element.options.disabled"
        >
          <a-radio
            v-for="item of element.options.options"
            :key="item.value"
            :value="item.value"
            :style="{
              display: element.options.inline ? 'inline-block' : 'block'
            }"
          >
            <span class="radio-span">{{ element.options.showLabel ? item.label : item.value }}</span>
          </a-radio>
        </a-radio-group>
      </template>
      <template v-if="element.type === 'upload'">
        <a-upload
          :name="element.options.file"
          action="/api/ces/upload"
          :accept="element.options.accept"
          :file-list="element.options.defaultValue"
          :listType="element.options.listType"
          :multiple="element.options.multiple"
          :disabled="element.options.disabled"
        >
          <div v-if="element.options.listType === 'picture-card'">
            <Icon :icon="'upload-cloud-2-line'" />
            <p>点击上传</p>
          </div>
          <a-button v-else>
            <Icon :icon="'upload-cloud-2-line'" />
            <p>点击上传</p>
          </a-button>
        </a-upload>
      </template>
      <template v-if="element.type === 'checkbox'">
        <a-checkbox-group
          :value="element.options.defaultValue"
          :style="{ width: element.options.width }"
          :disabled="element.options.disabled"
        >
          <a-checkbox
            v-for="item of element.options.options"
            :key="item.value"
            :value="item.value"
            :style="{
              display: element.options.inline ? 'inline-block' : 'block'
            }"
          >
            {{
            element.options.showLabel ? item.label : item.value
            }}
          </a-checkbox>
        </a-checkbox-group>
      </template>
      <template v-if="element.type === 'time'">
        <a-date-picker
          :size="config.size"
          :value="element.options.defaultValue"
          :placeholder="element.options.placeholder"
          :inputReadOnly="element.options.readonly"
          :allowClear="element.options.allowClear"
          :format="element.options.format"
          :disabled="element.options.disabled"
          :style="{ width: element.options.width }"
        />
      </template>
      <template v-if="element.type == 'text'">
        <span>{{ element.options.defaultValue }}</span>
      </template>
    </a-form-item>
    <div class="widget-view-action" v-if="selectWidget?.key === element.key">
      <div class="svg-icon" @click.stop="$emit('copy')">
        <Icon :icon="'file-copy-line'" />
      </div>
      <div class="svg-icon" @click.stop="$emit('delete')">
        <Icon :icon="'delete-bin-6-line'" />
      </div>
    </div>

    <div class="widget-view-drag" v-if="selectWidget?.key === element.key">
      <div class="svg-icon drag-widget">
        <Icon :icon="'drag-move-2-line'" />
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import Icon from "@/layout/icon";
// 导入的其他文件 例如：import moduleName from 'modulePath';
export default defineComponent({
  name: "WidgetFormItem",
  components: {
    Icon
  },
  props: {
    config: {
      type: Object,
      required: true
    },
    element: {
      type: Object,
      required: true
    },
    selectWidget: {
      type: Object
    }
  }
});
</script>
<style lang="less">
// .widget-view .ant-col {
//   width: 21%;
//   overflow: hidden;
//   text-overflow: ellipsis;
//   white-space: nowrap;
//   word-break: keep-all;
// }
.widget-view label {
  width: 21%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-break: keep-all;
  cursor: pointer;
}
.widget-view .ant-form-item-control-wrapper {
  flex: 1 !important;
}
.widget-view .ant-form-item-control {
  height: 100%;
}
.widget-view .ant-form-item-control .ant-form-item-children {
  height: 100%;
  #flex-box.row-start-c();
  width: 100%;
}
.widget-view .ant-form-item-control .ant-form-item-children .ant-radio-group,
.ant-checkbox-group {
  height: 100%;
  #flex-box.column-start-start();
  width: 100%;
}
.widget-view
  .ant-form-item-control
  .ant-form-item-children
  .ant-checkbox-wrapper {
  margin-left: 0 !important;
}
textarea.ant-input {
  margin-top: 10px;
}
.ant-upload .ant-btn {
  #flex-box.row-start-c();
  margin-top: 5px;
}
</style>
<style lang='less' scoped>
//@import url(); 引入公共css类
.radio-span {
  width: 200px;
}
.widget-item-container {
  position: relative;
  .widget-view-action {
    display: flex;
    position: absolute;
    right: 0;
    bottom: -2px;
    height: 28px;
    line-height: 28px;
    background: #409eff;
    z-index: 10;
    .svg-icon {
      font-size: 14px;
      color: #fff;
      margin: 0 5px;
      cursor: pointer;
    }
  }
  .widget-view-drag {
    position: absolute;
    height: 28px;
    left: 0;
    top: -2px;
    line-height: 28px;
    background: #409eff;
    z-index: 10;
    .svg-icon {
      font-size: 14px;
      color: #fff;
      margin: 0 5px;
      cursor: move;
    }
  }
}
.widget-view {
  padding-bottom: 18px;
  position: relative;
  border: 1px dashed rgba(170, 170, 170, 0.7);
  background-color: rgba(236, 245, 255, 0.3);
  margin: 2px;
  .widget-view-description {
    height: 15px;
    line-height: 15px;
    font-size: 13px;
    margin-top: 6px;
    color: #909399;
  }
  &:after {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    display: block;
  }
  &:hover {
    background: #ecf5ff;
    outline: 1px solid #409eff;
    outline-offset: 0;
    &.active {
      outline: 2px solid #409eff;
      border: 1px solid #409eff;
      outline-offset: 0;
    }
    .widget-view-drag {
      display: block;
    }
  }
  &.active {
    outline: 2px solid #409eff;
    border: 1px solid #409eff;
  }
  &.ghost {
    background: #f56c6c;
    border: 2px solid #f56c6c;
    outline-width: 0;
    height: 3px;
    box-sizing: border-box;
    font-size: 0;
    content: "";
    overflow: hidden;
    padding: 0;
  }
}
</style>